import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { Article } from '@interfaces/homepage';
import { article_path } from '@routes';
import { ClickTarget, click } from '@tracking';

const ModalArticle = ({ id, isPro, picture, slug, title, authors, excerpt }: Article) => {
  const { trackEvent } = useEventTracking();

  return (
    <article>
      <div className="pl-24 sm:pl-88 md:pl-80">
        <ArticleImage
          className="aspect-[16/9] !h-auto w-[160px]"
          id={id}
          isPro={isPro}
          picture={picture}
          sizes="200px"
          slug={slug}
          title={title}
        />
        <ArticleHeader
          slug={slug}
          title={title}
          theme={Theme.Dark}
          className="!my-8 text-headline-xxs"
        />
        <Byline authors={authors} theme={Theme.Dark} />
      </div>
      <div className="mt-16 h-2 w-full bg-grayscale-gray" />
      <p className="mb-0 mt-16 hidden pl-88 font-suisse-intl text-overline-md text-white sm:block md:pl-80">
        <a
          href={article_path(slug)}
          className="line-clamp-3 hover:text-primary-magenta"
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Excerpt, clickText: excerpt.long }))
          }
        >
          {excerpt.long}
        </a>
      </p>
    </article>
  );
};

export default ModalArticle;
